export enum FlowType {
  AP_TO_SRP = 'APToSRP',
  SRP_SCROLL = 'SRPScroll'
}

export enum InfoType {
  PriceAlerts = 'PriceAlerts'
}
